import { DataWrapper, IDataWrapper } from "@/shared/model/global/data-wrapper.model";
import { ICreatePublicRequest } from "@/shared/model/modulable/create-public-request.model";
import { IModulableGameVM } from "@/shared/model/modulable/modulable-game-VM.model";
import { ISurveysModulableVM } from "@/shared/model/surveys-modulable-vm.model";
import axios from "axios";

const baseApiUrl = "api/modulable-game";

export default class ModulableGameService {
  updateClient(data: DataWrapper) {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/update-client`, data)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public createPublicData(request: ICreatePublicRequest): Promise<IModulableGameVM> {
    return new Promise<IModulableGameVM>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/create-public-data`, request)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public update(entity: IDataWrapper): Promise<IModulableGameVM> {
    return new Promise<IModulableGameVM>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/update`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public findEncrypted(id: any): Promise<IModulableGameVM> {
    return new Promise<IModulableGameVM>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/find-encrypted`, id)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public saveClient(data): Promise<IModulableGameVM> {
    return new Promise<IModulableGameVM>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/save-client`, data)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public compute(id): Promise<IModulableGameVM> {
    return new Promise<IModulableGameVM>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/compute`, id)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getResult(id): Promise<IModulableGameVM> {
    return new Promise<IModulableGameVM>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/get-result/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public updateSurveys(entity: ISurveysModulableVM): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/update-surveys`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public updateFeedback(entity: any, id: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(baseApiUrl + "/" + id + "/feedback", entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public updateSequence(entity: IModulableGameVM): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(baseApiUrl + "/" + entity.encryptedId + "/sequence", entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public saveAddress(entity: DataWrapper): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/save-address`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
